import styled from '@emotion/styled'
import { colors, font, radius, spacing } from '@mobi/component-library/Theme/Common'
import React from 'react'

interface HelpTextProps {
  children: React.ReactNode
  margin?: string
}

export const HelpText: React.FC<HelpTextProps> = ({ children, margin = '-4px 32px' }) => {
  return <StyledHelpText margin={margin}>{children}</StyledHelpText>
}

const StyledHelpText = styled.div<{ margin: string }>(({ margin }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: `${spacing.bigx1} ${spacing.smx1}`,
  backgroundColor: colors.neutral[100],
  borderRadius: radius.md,
  fontFamily: font.family.primary,
  color: colors.neutral[800],
  ...font.size.sm,
  margin,

  p: {
    ...font.size.sm,
    margin: 0,
  },
}))
